module.exports = __webpack_public_path__ + "img/direction_headerimage.0f4938d5.jpg";